import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface FinalSaleReturnState {
  validCollections: readonly string[];
  validProductTags: readonly string[];
}

export const FINAL_SALE_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<FinalSaleReturnState>>,
): ConditionType<FinalSaleReturnState, Condition.FinalSaleReturn> => ({
  name: "Final sale return item",
  description(state) {
    return "Item is a final sale return";
  },
  Details(props: ConditionTypeDetailsProps<FinalSaleReturnState>) {
    return React.createElement(Details, props);
  },
  empty: { validCollections: [], validProductTags: [] },
  fromModel(model) {
    return {
      validCollections: model.validCollections,
      validProductTags: model.validProductTags,
    };
  },
  toModel(state) {
    return {
      type: Condition.FINAL_SALE_RETURN,
      validCollections: state.validCollections,
      validProductTags: state.validProductTags,
    };
  },
  valid(state) {
    return true;
  },
});
